<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>


<div class="container-fluid">
  <div class="top-header">
    <div>
      <img src="../../../../assets/img/backMenu.svg" alt="" (click)="backClicked()">
    </div>
    <div class="taste-rating-title">Your Review</div>
  </div>
</div>

<div class="container">
  <div>
    <div class="food-dish-name">
      {{DishName}}
    </div>
    <div class="order-number" *ngIf="orderIdFromParam">
      Order No : {{orderIdFromParam}}
    </div>
  </div>
  <form [formGroup]="reviewForAllergyForm">
    <div class="allergy-div">
      <div class="allergy-rating">
        Allergy Rating
      </div>
      <div class="d-flex justify-content-between pad-top-15">
        <div>
          <button class="btn-found-safe" type="button" formControlName="safeButton"
            (click)="checkSafe()" *ngIf="safevalue == '1'">Found this safe</button>
          <button class="btn-found-safe-gray" [ngClass]="{'btn-found-safe-gray-clicked': safeClassFlag}" type="button"
            formControlName="safeButton" (click)="checkSafe()" *ngIf="safevalue == '0'">Found this safe</button>
        </div>
        <div>
          <button class="btn-found-unsafe" type="button" formControlName="safeButton" (click)="checkUnsafe()"
            *ngIf="safevalue == '1'">Found this unsafe</button>
          <button class="btn-found-unsafe-red" type="button" formControlName="safeButton" (click)="checkUnsafe()"
            *ngIf="safevalue == '0'">Found this unsafe</button>
        </div>
      </div>
    </div>

    <div *ngIf="unsafeBool">
      <div class="text-area">
        <textarea name="" id="" cols="30" rows="10" class="form-control"
          placeholder="You have selected unsafe option, Please let us know your feedback"
          formControlName="unSafeTextValue"></textarea>
      </div>
    </div>

    <div class="taste-score">
      <div class="taste-score-text">
        Taste Score
      </div>

      <div class="star-ratings">
        <tc-rating [value]="starRatings" formControlName="starRatings" [color]="['#d3dcb2','#a7bb5f','#479842']">
        </tc-rating>
      </div>

    </div>

    <div class="text-area">
      <textarea name="" id="" cols="30" rows="10" class="form-control" placeholder="Please enter your reviews"
        formControlName="tasteScore"></textarea>
    </div>

    <div class="pad-top-10">
      <div style="text-align: center;">
        <div *ngIf=" f.starRatings.invalid && submitted" class="text-danger">
          <div *ngIf="f.starRatings.errors && f.starRatings.errors.required">
            <!-- <mat-chip>Please provide taste score
            </mat-chip> -->
            <div>Please provide taste score</div>
          </div>
        </div>
        <div *ngIf="f.safeButton.invalid && submitted" class="text-danger">
          <div *ngIf="f.safeButton.errors && f.safeButton.errors.required">
            <!-- <mat-chip>Please select allergy rating
            </mat-chip> -->
            <div>Please select allergy rating</div>
          </div>
        </div>
      </div>
    </div>
    <!-- [disabled]="!reviewForAllergyForm.valid"  -->
    <div class="submit-btn-div">
      <button class="btn-submit" type="submit" (click)="postUserReviews()">Submit</button>
    </div>
  </form>
</div>